import { useTranslation } from 'react-i18next'
import IncidentForm from './IncidentForm'

const IncidentsSelfService = () => {
  const { t } = useTranslation()

  return (
    <IncidentForm
      title={t('label.self.service.incident.create')}
      description={t('label.self.service.incident.description')}
    />
  )
}

export default IncidentsSelfService
